/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable consistent-return */
/* eslint-disable import/no-extraneous-dependencies */
import { RoutesUtil as Util } from '@leverege/molten/routes'
import { Button, Flex, Pane } from '@leverege/ui-elements'
import { push } from 'connected-react-router'
import { useCallback, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import useTimeKeyInterval from '../cycleTimeMonitoring/hooks/useTimeKeyInterval'
import BondedTable from './components/BondedTable'
import OverallPaceCard from './components/OverallPaceCard'
import PaceOverviewCards from './components/PaceOverviewCards'
import ShellsTable from './components/ShellsTable'
import S from './FactoryCycleTimeMonitoring.css'

function FactoryCycleTimeMonitoring( props ) {
  const { delegate, dispatch, match } = props
  const [ lines, setLines ] = useState( [] )
  const { timeKey } = useTimeKeyInterval( 30 )
  const [ usePortal, setUsePortal ] = useState( false )

  const loadLines = async () => {
    const res = await dispatch( delegate.child( 'molds' ).list() )
    setLines( res.items )
  }

  const onClickView = ( line ) => {
    const path = match ?
      Util.resolve(
        `/p/:persona/location/:locationId/molds/${line.id}/cycleTimeMonitoring?v=s:CycleTimeMonitoring`,
        match,
      ) :
      ''
    dispatch( push( path ) )
  }

  const fgJob = line => line?.data?.finishedGoodsJob?.data

  const onRenderPortal = useCallback( ( add ) => {
    if ( add ) {
      for ( const child of document.body.children ) {
        child.classList.add( S.hidden )
      }
    } else {
      document.body.classList.remove( S.bodySize )
      for ( const child of document.body.children ) {
        child.classList.remove( S.hidden )
      }
    }

    setUsePortal( add )
  }, [ usePortal ] )

  useEffect( () => {
    const handleKeyDown = ( event ) => {
      if ( event.key === 'Escape' ) {
        const path = match ?
          Util.resolve(
            '/p/:persona/location/:locationId/factoryCycleTimeMonitoring?v=t-location%3ACycleTimeMonitoring',
            match,
          ) :
          ''
        dispatch( push( path ) )
      }
    }

    document.addEventListener( 'keydown', handleKeyDown )
    
    return () => {
      document.removeEventListener( 'keydown', handleKeyDown )
    }
  }, [] )

  useEffect( () => {
    setTimeout( () => {
      onRenderPortal( match?.path?.includes( 'embed' ) )
    }, 100 )

    return () => onRenderPortal( false )
  }, [ match?.path ] )

  useEffect( () => {
    loadLines()
  }, [ timeKey ] )

  const content = (
    <Flex variant='colM' className={usePortal && S.embedded}>
      {lines.map( ( line, i ) => (
        <Pane variant='factoryDashboardCardCustom' className={S.card}>
          <Pane
            layout='flex:rowSpaceBetween'
            style={{ alignItems : 'center' }}
            variant='factoryDashboardCardCustomHeader'>
            {fgJob( line )?.jobId ?? '-'}
            {!usePortal && (
              <Button variant='goToLaneButton' onClick={() => onClickView( line )}>
                <span>View {line.name}</span>
                <i className='fa-solid fa-arrow-up-right' />
              </Button>
            )}
          </Pane>
          <Pane
            variant='factoryDashboardCardCustomArea'
            className={S.cardArea}>
            <Flex gap={10} className={S.cardContent}>
              <OverallPaceCard fgJob={fgJob( line )} />
              <Flex variant='col' gap={10} style={{ width : '100%' }}>
                <PaceOverviewCards fgJob={fgJob( line )} />
                <Flex gap={10}>
                  <ShellsTable
                    fgJob={fgJob( line )}
                    delegate={delegate}
                    dispatch={dispatch}/>
                  <BondedTable
                    fgJob={fgJob( line )} 
                    delegate={delegate}
                    dispatch={dispatch}/>
                </Flex>
              </Flex>
            </Flex>
          </Pane>
        </Pane>
      ) )}
    </Flex>
  )

  if ( usePortal ) {
    return ReactDOM.createPortal(
      content,
      document.body
    )
  }

  return content
}

export default FactoryCycleTimeMonitoring
